export class QtdNotasMes {
  qtdNota: number | null = null
  mes: number | null = null
}
